import { useEffect, useState } from 'react'
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore'
import { db } from '../firebase'

/**
 * Live list of requests for a user. Returns `null` while loading / when uid is missing.
 */
export function useUserRequests(uid) {
  const [requests, setRequests] = useState(null)

  useEffect(() => {
    if (!uid) {
      setRequests(null)
      return undefined
    }

    const requestsQuery = query(
      collection(db, 'users', uid, 'requests'),
      orderBy('created_at', 'desc')
    )

    return onSnapshot(requestsQuery, (snapshot) => {
      setRequests(
        snapshot.docs.map((docSnap) => ({
          ...docSnap.data(),
          request_id: docSnap.id,
        }))
      )
    })
  }, [uid])

  return requests
}
